import React, { useEffect, useState } from 'react'
import { FileIcon } from '@entur/icons'
import { useToast } from '@entur/alert'
import { OverflowMenuItem } from '@entur/menu'
import { useEmployee } from '../../contexts/employee-context'
import { FamilyMember, Fetch, FetchState } from '../../api-clients/api-types'
import { trackEvent } from '../../utils/tracking-utils'
import { PostalAddressModal } from './postal-address-modal'
import { useDownloadableApi } from '../../api-clients/client-hooks'
import { getTicketRightHoldersFile } from '../../api-clients/eba-clients'

type PostalAddressProps = {
  familyMembers: Fetch<FamilyMember[]>
  setErrorMessage: (errorMsg: string | undefined) => void
}

export const PostalAddress: React.FC<PostalAddressProps> = ({ familyMembers, setErrorMessage }) => {
  const { employee } = useEmployee()
  const [open, setOpen] = useState(false)
  const { addToast } = useToast()
  const [postalAddressResponse, downloadPostalAddress] = useDownloadableApi(getTicketRightHoldersFile)

  useEffect(() => {
    if (postalAddressResponse.status === FetchState.ERROR) {
      setErrorMessage('Kan ikke lage etikett')
    }
  }, [postalAddressResponse, setErrorMessage])

  const openPostAddressModalOrDownloadAddress = () => {
    const shouldShowPostalAddressModal =
      (familyMembers.status === FetchState.SUCCESS && familyMembers.data.length > 0) ||
      familyMembers.status !== FetchState.SUCCESS

    if (shouldShowPostalAddressModal) {
      trackEvent('Download-Address', { category: 'Employee' })
      setOpen(true)
    } else {
      const query = new URLSearchParams({
        employeeNo: employee.employeeNo,
        firstName: employee.firstName,
        surname: employee.surname,
        dateOfBirth: employee.dateOfBirth.toString(),
        companyId: employee.company.companyId.toString(),
        format: 'addresses-pdf',
      }).toString()

      addToast({ variant: 'info', content: 'Laster ned postadresser...' })
      downloadPostalAddress({
        query: `?${query}`,
        backupFileName: `postadresse.pdf`,
      })
    }
  }

  return (
    <>
      <OverflowMenuItem
        className="postal-address-download-button"
        data-cy="postal-address-download-button"
        onSelect={openPostAddressModalOrDownloadAddress}
      >
        <span aria-disabled>
          <FileIcon inline />
          Etikett
        </span>
      </OverflowMenuItem>
      <PostalAddressModal
        open={open}
        close={() => setOpen(false)}
        employee={employee}
        familyMembersResponse={familyMembers}
        download={downloadPostalAddress}
        downloadResponse={postalAddressResponse}
      />
    </>
  )
}
